<template>
  <div class="deliveryPolicy">
    <section class="main_section">
      <div class="page-contentbox">
        <a @click="goBack" class="back-link">
          <i class="material-icons">arrow_back_ios</i> Back
        </a>
        <h2>Delivery Policy</h2>
        <p>Free Shipping</p>
        <p>Rovi91 Innovations Pvt Ltd provides free shipping on all items if your total order amount is more than Rs. 10,000. Otherwise we charge Rs. 50 as shipping charges.</p>
        <p>All items get delivered within 1 day of receipt of order.</p>
        <p>With every order, you will receive an email and mobile app notification containing the details of the order placed by you. Once the items are shipped, you will receive another email and mobile app notification containing the shipping details. You can also access 'My Orders' on site or mobile app to see the details of all your placed orders.</p>
        <p>Our prices are all inclusive. All taxes are indicated separately with the listed prices.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DeliveryPolicy",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
